import { ComponentProps, forwardRef, Ref } from 'react';
import { InputRef } from 'antd';
import './style.scss';
import AntdInput from 'antd/es/input';

function Input(props: ComponentProps<typeof AntdInput>, ref: Ref<InputRef>) {
    return <AntdInput ref={ref} size="large" {...props} />;
}

Input.displayName = 'Input';

// @ts-ignore
export default forwardRef(Input);
